
<template>
  <div class="wraper">
    <template>

      <el-backtop target=".wraper">
        <div style="{
                        height: 100%;
                        width: 100%;
                        background-color: #f2f5f6;
                        box-shadow: 0 0 6px rgba(0,0,0, .12);
                        text-align: center;
                        line-height: 40px;
                        color: #1989fa;
                    }">
          TOP
        </div>
      </el-backtop>
    </template>
    <div>返回顶部</div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>
<style scoped>
.wraper {
  height: 100vh;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/GSCSH_month.vue